import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AccountResponse } from 'src/app/models/account.model';
import { SimplePaginationModel } from 'src/app/models/pagination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountService } from 'src/app/services/account.service';
import { BamTransferServiceService } from 'src/app/services/bam-transfer-service.service';

@Component({
  selector: 'app-bam-query-mt940',
  templateUrl: './bam-query-mt940.component.html',
  styleUrls: ['./bam-query-mt940.component.scss']
})
export class BamQueryMt940Component implements OnInit {
  accounts: AccountResponse[] = [];
  filterAccounts: AccountResponse[] = [];
  filterAccountsDebit: AccountResponse[] = [];
  selectedOwnAccount: string | null = null;
  totalElement = 0;
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  startDate = new Date().toLocaleDateString('en-CA');
  endDate = new Date().toLocaleDateString('en-CA');
  paginationApplications: SimplePaginationModel = new SimplePaginationModel(0, 5, 0, 0, 0);
  sizes = [5, 10, 25, 50, 100];
  loading = false;

  constructor(private toastService: ToastrService, private accountService: AccountService, private bamTransferService: BamTransferServiceService) { }

  ngOnInit(): void {
    this.getBanksOwn();
  }

  getBanksOwn() {
    this.accountService.getAccounts().subscribe({
      next: (response: ResponseObject) => {
        this.accounts = response.data;
        this.filterAccounts = this.accounts;
        this.filterAccountsDebit = this.accounts.filter(account => account.bank == 4);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al crear la cuenta");
      }
    })
  }

  getMovements() {
    if (!this.selectedOwnAccount) {
      return;
    }
    const data = {
      bankAccountNumber: this.selectedOwnAccount,
      initDate: this.startDate,
      endDate: this.endDate,
    }

    this.loading = true;
    this.bamTransferService.getAccountMovement(data).subscribe({
      next: (response: ResponseObject) => {
        console.log(response.data);
        this.pagination.total = response.data.movements ?? [];
        this.pagination.total = this.pagination.total.reverse();
        this.pagination.filter = response.data.movements;
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener movimientos");
        this.loading = false;
      }
    });
  }
}

